import type * as React from 'react';
import { getFile } from '@Domain/Api';
import displayedLogoFetched, {
	type DisplayedLogoFetchedAction,
} from '@Application/Branding/DisplayedLogo/Actions/displayedLogoFetched';
import displayedLogoFetchFailed, {
	type DisplayedLogoFetchFailedAction,
} from '@Application/Branding/DisplayedLogo/Actions/displayedLogoFetchFailed';
import type FetchDisplayedLogo from '@Application/Branding/DisplayedLogo/Queries/FetchDisplayedLogo';
import readCurrentOrganization from '@Application/Organizations/CurrentOrganization/readCurrentOrganization';
import recordDisplayedLogo from '@Application/Branding/DisplayedLogo/recordDisplayedLogo';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import readBlobAsDataUrl from '@Infra/DataUrl/readBlobAsDataUrl';
import parameters from '../../../parameters';

type Actions = DisplayedLogoFetchedAction | DisplayedLogoFetchFailedAction;

export default (query: FetchDisplayedLogo) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const { blob } = await getFile(
				`${parameters.api.host}/api/organizations/${query.organizationId}/effective-logo`,
			);
			// A 204 yields an empty Blob: no logo at this level.
			const dataUrl = blob.size === 0 ? null : await readBlobAsDataUrl(blob);

			// A response that outlives a structure change must not memorize the structure just left.
			if (query.organizationId === readCurrentOrganization()) {
				recordDisplayedLogo(dataUrl);
			}

			const action = displayedLogoFetched({ dataUrl }, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = displayedLogoFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
